import { supabase } from "../supabaseClient";
import { replaceSquadEvents } from "./squadEventNames";

const LIST_MINUTES = ["00", "30"];

const formatTimeLabel = (value) => {
  const [hours, minutes] = value.split(":");
  const hour = parseInt(hours, 10);
  const period = hour >= 12 ? "PM" : "AM";
  const displayHour = hour > 12 ? hour - 12 : hour === 0 ? 12 : hour;
  return `${displayHour}:${minutes} ${period}`;
};

export const SQUAD_TIME_OPTIONS = Array.from({ length: 24 }, (_, hour) =>
  LIST_MINUTES.map((minute) => {
    const value = `${String(hour).padStart(2, "0")}:${minute}`;
    return { value, label: formatTimeLabel(value) };
  })
).flat();

export const CUSTOM_SQUAD_TIME = "__custom__";
export const NOON_SQUAD_TIME = "12:00";

export const normalizeSquadTime = (value) => {
  if (!value || value === CUSTOM_SQUAD_TIME) return "";
  const [hourPart, minutePart] = String(value).split(":");
  const hour = parseInt(hourPart, 10);
  const minute = parseInt((minutePart || "00").slice(0, 2), 10);
  if (Number.isNaN(hour) || Number.isNaN(minute)) return "";
  return `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`;
};

export const isListedSquadTime = (value) =>
  SQUAD_TIME_OPTIONS.some((option) => option.value === normalizeSquadTime(value));

export const squadTimeLabel = (value) => {
  const normalized = normalizeSquadTime(value);
  return normalized ? formatTimeLabel(normalized) : "";
};

export const createSquadWithTemplates = async ({
  tournamentID,
  squadTime,
  squadDate,
  eventIds = [],
  squadLocation,
  templateIds = [],
}) => {
  const { data, error } = await supabase
    .from("squads")
    .insert([
      {
        squadTime,
        squadDate,
        tournamentID,
        squadLocation,
      },
    ])
    .select();

  if (error) throw error;
  if (!data || data.length === 0) {
    throw new Error("Creation failed: No squad was created.");
  }

  const squadId = data[0].id;
  await replaceSquadEvents(squadId, eventIds);

  if (templateIds.length > 0) {
    const { error: instancesError } = await supabase.rpc(
      "create_squad_event_instances",
      {
        p_squad_id: squadId,
        p_template_ids: templateIds,
        p_custom_names: null,
      }
    );
    if (instancesError) throw instancesError;
  }

  return data[0];
};
